// @ts-check
import React from "react";
import SearchBox from "../../common_nextgen/common_components/SearchScreenComponents/SearchBox";  
import DisplayTable from "../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";  
import ButtonsSection from "../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";  
import NextGenPaginator from "../../common_nextgen/common_components/Pagination/NextGenPaginator";  
import ConfirmationModal from "../../common_nextgen/common_components/Modal/ConfirmationModal";  
import useAdjustmentReasonCode from "./hooks/useAdjustmentReasonCode";  

/**
 * @typedef {import("./AdjustmentReasonCode.typedef.mjs").AdjustmentReasonCodeComponentProps} AdjustmentReasonCodeComponentProps
 * @param {AdjustmentReasonCodeComponentProps} props 
 * @returns {JSX.Element}
 */
const AdjustmentReasonCode = (props) => {
  const {
    selectMode,
    onSelect = () => {}, 
    hideModal = () => {},
    params,
    lookupType
  } = props;
  const adjustmentReasonCodeData = useAdjustmentReasonCode({
    selectMode,
    onSelect,
    hideModal,
    params,
    lookupType
  });  
  
  return (  
    <div className="container container-fluid">  
    <ButtonsSection ctaButtons={adjustmentReasonCodeData.leftButtons} align="left" /> 
      <div className="header-section">  
        <h1>  
          {adjustmentReasonCodeData.screen_title} -{" "}  
          <span className="heading-cod">{adjustmentReasonCodeData.screenNumber}</span>  
        </h1>  
      </div>  
      <SearchBox  
        formFields={adjustmentReasonCodeData.formFields}  
        dropdownValues={adjustmentReasonCodeData.dropdownValues}  
        paramsData={adjustmentReasonCodeData.paramsData}  
        updataParamData={adjustmentReasonCodeData.updateParamData}  
      />  
      <ButtonsSection ctaButtons={adjustmentReasonCodeData.ctaButtons} />  
      <DisplayTable  
        selectMode={adjustmentReasonCodeData.selectMode}
        data={adjustmentReasonCodeData.data}  
        parmKey={adjustmentReasonCodeData.parmKey}  
        menuOptions={adjustmentReasonCodeData.menuOptions}  
        tableHeaders={adjustmentReasonCodeData.columnDef}  
        setRowData={adjustmentReasonCodeData.setRowData}  
        selectedPriceSchedules={adjustmentReasonCodeData.selectedRows}  
        setSelectedPriceSchedules={adjustmentReasonCodeData.setSelectedRows}  
      />  
      <div className="paginator-container">  
        <NextGenPaginator  
          first={adjustmentReasonCodeData.first}  
          rows={adjustmentReasonCodeData.rows}  
          totalRecords={adjustmentReasonCodeData.totalRecords}  
          currentPage={adjustmentReasonCodeData.currentPage}  
          rowsPerPageOptions={[10, 25, 50]}  
          onPageChange={adjustmentReasonCodeData.onPageChange}  
        />  
      </div>  
      {adjustmentReasonCodeData.isConfirmationModalOpen && (  
        <ConfirmationModal  
          isOpen={adjustmentReasonCodeData.isConfirmationModalOpen}  
          onRequestClose={adjustmentReasonCodeData.closeConfirmationModal}  
          onBack={adjustmentReasonCodeData.closeConfirmationModal}  
          onSave={adjustmentReasonCodeData.deleteAdjustmentReasonCode}  
          confirmLabel="Confirm(Y/N)"  
          options={[  
            { label: "N-No", value: "no" },  
            { label: "Y-Yes", value: "yes" },  
          ]}  
          setSelectedOption={adjustmentReasonCodeData.setSelectedOption}  
        />  
      )}  
    </div>  
  );  
};  
  
export default AdjustmentReasonCode;  
